import { render, staticRenderFns } from "./PoolsTab.vue?vue&type=template&id=cf3da500&scoped=true&"
import script from "./PoolsTab.vue?vue&type=script&lang=js&"
export * from "./PoolsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3da500",
  null
  
)

export default component.exports